import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectPlayerLevel } from "../../selectors/selectPlayerLevelInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { BigCharacter } from "../generic/big-character/BigCharacter";
import { IdBigCharacter } from "../generic/big-character/IdBigCharacter";
import { ButtonSecondaryAccentLarge } from "../generic/common/ButtonSecondaryAccentLarge";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionOngoingPurchaseCharacterHelpClose } from "../ongoing-purchase/actionOngoingPurchase";
import { actionShowMeInsufficientLevel, actionShowMeMissingWorkers } from "../show-me/actionShowMe";
import { TransparentDialogWrapper } from "../transparent-dialog/TransparentDialogWrapper";
import { IdCharacterHelpType } from "./IdCharacterHelpType";
var _DialogCharacterHelp = function (_a) {
    var dialogInfo = _a.dialogInfo, playerLevel = _a.playerLevel, onCancel = _a.onCancel, onInsufficientLevel = _a.onInsufficientLevel, onMissingWorkers = _a.onMissingWorkers;
    var type = dialogInfo.type, missing = dialogInfo.missing;
    var characterDialogTitle;
    var characterDialogDescription;
    var showMeButtonAction;
    switch (type) {
        case IdCharacterHelpType.MissingPlayerLevel:
            var locaReplacements = new Map([[ReplacementLoca.amount, missing]]);
            characterDialogDescription = (React.createElement(TextLoca, { id: IdLoca.help_missingPlayerlevel_desc, replacements: locaReplacements }));
            characterDialogTitle = React.createElement(TextLoca, { id: IdLoca.help_missingPlayerlevel_title });
            showMeButtonAction = onInsufficientLevel;
            break;
        case IdCharacterHelpType.MissingWorkers:
            characterDialogDescription = React.createElement(TextLoca, { id: IdLoca.help_missingWorkers_desc });
            characterDialogTitle = React.createElement(TextLoca, { id: IdLoca.help_missingWorkers_title });
            showMeButtonAction = onMissingWorkers;
    }
    return (React.createElement("div", { className: "character-help__overlay", onClick: onCancel },
        React.createElement(TransparentDialogWrapper, null,
            React.createElement("div", { className: "character-help__dialog" },
                React.createElement(BigCharacter, { className: "flex__full big-character-flip", name: IdBigCharacter.TessaLeftSide }),
                React.createElement("div", { className: "character-help__balloon" },
                    React.createElement("div", { className: IdStyles.CharacterHelpDescriptionBackground },
                        React.createElement("div", { className: IdStyles.TextBoldAccent }, characterDialogTitle),
                        React.createElement("div", { className: IdStyles.TextNormal }, characterDialogDescription)),
                    React.createElement("div", { className: "character-help__button" },
                        React.createElement(ButtonSecondaryAccentLarge, { onClick: showMeButtonAction },
                            React.createElement("div", { className: "flex flex--stacked flex--guts" },
                                React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.showMe })),
                                React.createElement("div", { className: "flex flex--guts" },
                                    React.createElement(Icon, { icon: IdIcon.GreenArrowIcn, styleId: IdStyles.IconMedium }))))))))));
};
var mapState = function (state) { return ({
    dialogInfo: state.ongoingPurchase.characterHelp,
    playerLevel: selectPlayerLevel(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCancel: function () { return dispatch(actionOngoingPurchaseCharacterHelpClose()); },
    onInsufficientLevel: function () { return dispatch(actionShowMeInsufficientLevel()); },
    onMissingWorkers: function () { return dispatch(actionShowMeMissingWorkers()); },
}); };
export var DialogCharacterHelp = connect(mapState, mapDispatch)(_DialogCharacterHelp);



//////////////////
// WEBPACK FOOTER
// ./src/features/character-help-dialog/DialogCharacterHelp.tsx
// module id = 2553
// module chunks = 3